// src/components/react-table/DefaultColumnFilter.tsx

import { ClearTwoTone } from '@mui/icons-material'
import { IconButton, InputAdornment, TextField } from '@mui/material'

type Props = {
  column: {
    filterValue: any
    setFilter: (value: any) => void
  }
  placeholder?: string
  size?: 'small' | 'medium'
}

export const DefaultColumnFilter = ({
  column: { filterValue, setFilter },
  placeholder = 'Filter ...',
  size = 'small',
}: Props) => {
  const onChange = event => setFilter(event.target.value || undefined)
  const clearFilter = () => setFilter(undefined)
  const value = filterValue || ''

  return (
    <TextField
      InputProps={{
        endAdornment: value && (
          <InputAdornment
            position={'end'}
            sx={{ position: 'absolute', right: 0 }}
          >
            <IconButton
              onClick={clearFilter}
              edge={'end'}
              size={'small'}
              sx={{ p: 1 }}
            >
              <ClearTwoTone />
            </IconButton>
          </InputAdornment>
        ),
      }}
      onChange={onChange}
      placeholder={placeholder}
      size={size}
      value={value}
    />
  )
}
